import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
interface ShutterOverlayProps {
  isActive: boolean;
}
export function ShutterOverlay({
  isActive
}: ShutterOverlayProps) {
  return <AnimatePresence data-id="element-324">
      {isActive && <motion.div initial={{
      opacity: 0,
      scale: 1
    }} animate={{
      opacity: 1,
      scale: 1.02
    }} exit={{
      opacity: 0,
      scale: 1
    }} transition={{
      duration: 0.15,
      exit: {
        duration: 0.3
      }
    }} className="fixed inset-0 z-[100] bg-white pointer-events-none" data-id="element-325" />}
    </AnimatePresence>;
}